/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.Axis = factory(root.BpmbuildProductionappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The Axis model module.
   * @module model/Axis
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>Axis</code>.
   * @alias module:model/Axis
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>Axis</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Axis} obj Optional instance to populate.
   * @return {module:model/Axis} The populated <code>Axis</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('ticks'))
        obj.ticks = ApiClient.convertToType(data['ticks'], 'String');
      if (data.hasOwnProperty('minValue'))
        obj.minValue = ApiClient.convertToType(data['minValue'], 'Number');
      if (data.hasOwnProperty('maxValue'))
        obj.maxValue = ApiClient.convertToType(data['maxValue'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('viewWindowOtherOptionKey'))
        obj.viewWindowOtherOptionKey = ApiClient.convertToType(data['viewWindowOtherOptionKey'], 'String');
      if (data.hasOwnProperty('otherOptionKey'))
        obj.otherOptionKey = ApiClient.convertToType(data['otherOptionKey'], 'String');
      if (data.hasOwnProperty('viewWindowMin'))
        obj.viewWindowMin = ApiClient.convertToType(data['viewWindowMin'], 'Number');
      if (data.hasOwnProperty('viewWindowMax'))
        obj.viewWindowMax = ApiClient.convertToType(data['viewWindowMax'], 'Number');
    }
    return obj;
  }

  /**
   * @member {String} ticks
   */
  exports.prototype.ticks = undefined;

  /**
   * @member {Number} minValue
   */
  exports.prototype.minValue = undefined;

  /**
   * @member {Number} maxValue
   */
  exports.prototype.maxValue = undefined;

  /**
   * @member {String} title
   */
  exports.prototype.title = undefined;

  /**
   * @member {String} viewWindowOtherOptionKey
   */
  exports.prototype.viewWindowOtherOptionKey = undefined;

  /**
   * @member {String} otherOptionKey
   */
  exports.prototype.otherOptionKey = undefined;

  /**
   * @member {Number} viewWindowMin
   */
  exports.prototype.viewWindowMin = undefined;

  /**
   * @member {Number} viewWindowMax
   */
  exports.prototype.viewWindowMax = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/Axis.js